;(function($, undefined){
    "use strict";

    var rnn = window.rnn, log, maps, forms, Form, Field;

    function initTagsSelector(element, settings) {
        element = $(element);

        var settings = settings || element.closest('[data-module]').data('module');

        element.select2({
            placeholder: settings.placeholder || 'Add a tag',
            width:'element',
            multiple: true,
            persistPlaceholder: true,
            minimumInputLength: 3,
            ajax: {
                url: rnn.site.tagsURL,
                dataType: 'json',
                data: function (term, page) {
                    return {
                        q: term,
                        limit: 10
                    };
                },
                results: function (data, page) { // parse the results into the format expected by Select2.
                    var results = [];
                    for(var key in data){
                        if(data.hasOwnProperty(key)){
                            results.push({
                                id:key,
                                text:key
                            });
                        }
                    }
                    return {results: results};
                }
            },
            initSelection: function (element, callback) {
                var data = [];
                $(element.val().split(",")).each(function () {
                    data.push({id: this, text: this});
                });



                callback(data);
            },
            tokenSeparators:[',']
            // Uncomment to add tag-adding support
            //,
            // createSearchChoice:function(term){
                // return {
                    // text: term,
                    // id: term
                // }
            // }
        });
    }

    function initTags(){

        log = rnn.logging.log;
        maps = rnn.modules.maps;
        forms = rnn.modules.forms;
        Form = forms.Form;
        Field = forms.Field;

        function addTag(tagsSelector, tags){
            var $container = $(tagsSelector).find(".select2-container");
            $container.select2("data", tags);
        }

        function TagsSelector(options){
            this.base.apply(this, arguments);
        }
        TagsSelector.prototype = Object.create(Field.prototype);
        TagsSelector.prototype.constructor = TagsSelector;
        TagsSelector.prototype.create = function(options){
            var input = $(this.inputElement = $.el.input({name:options.name})),
                settings = this.settings = {
                    element: input[0],
                    placeholder: 'Add a tag',
                    title: 'Tags'
                };

            this.element = rnn.modules.forms.createControlGroup(settings);

            return this;
        };
        TagsSelector.prototype.init = function(form, next){
            var tagsSelector = this,
                context = form.submission.context || form.submission.defaultContext;

            initTagsSelector(tagsSelector.inputElement, tagsSelector.settings);

            
            //Pre populated tags based on page context
            if (context !== undefined && context !== null) {

                var contentTypeId = context.contentTypeId;
                var objectId = context.objectId;

                if ((contentTypeId !== undefined && objectId !== undefined) && (contentTypeId !== null && objectId !== null)) {
                    $.ajax({
                        dataType: "json",
                        url: '' + rnn.site.getSubmissionTagsUrlPrefix+contentTypeId + '/' + objectId + '/',
                        success:function(data){
                            var results = [];
                            for(var key in data){
                                if(data.hasOwnProperty(key)){
                                    results.push({
                                        //id:data[key],
                                        id:key, //stupidest thing ever
                                        text:key
                                    });
                                }
                            }
                            tagsSelector.addTag(results);
                        }
                    });
                }
            }

            next();

            return tagsSelector;
        };
        TagsSelector.prototype.addTag = function(tags){
            addTag(this.element, tags);
            return this;
        };

        rnn.modules.tags.TagsSelector = TagsSelector;
    }

    rnn.modules.register('tags', {
        init: initTags
    });

})(jQuery);
